import { Dialog, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { lazy } from 'react';
import { AddCollaboratorsProps } from './AddCollaboratorsProps';
import { renderLazyComponent } from '../../../../utils/helpers';
import AddCollaboratorsLoader from './AddCollaboratorsLoader';

const LazyAddCollaborators = renderLazyComponent(
  lazy(() => import('./AddCollaboratorsContent')),
  <AddCollaboratorsLoader />
);

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    '& .MuiDialog-paper': {
      // maxWidth 720px
      maxWidth: theme.spacing(90),
    },
  },
}));

interface Props extends AddCollaboratorsProps {
  open: boolean;
  onClose: () => void;
}

const AddCollaboratorsDialog = (props: Props) => {
  const { open, onClose, ...rest } = props;
  const classes = useStyles();
  return (
    <Dialog
      className={classes.modal}
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        ...({ 'data-testid': 'modal-manage-collaborators' } as any),
      }}
    >
      <LazyAddCollaborators onClose={onClose} {...rest} />
    </Dialog>
  );
};

export default AddCollaboratorsDialog;
